import gatewayServer from "./gatewayServer"

const trackingMobileBaseUrl = gatewayServer.gatewayBaseUrl + "/tracking-mobile"

export default {
    getBaseUrl(){
        return trackingMobileBaseUrl
    }
}